import { fetchBaseQuery } from '@reduxjs/toolkit/query'
import {getAuthUser} from "../services/authService";

export const baseQuery = fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BASE_API_URL}/api/v2`,
    prepareHeaders: (headers) => {
        const code = process.env.REACT_APP_AZURE_KEY;

        if (!code) {
            console.error("No code in env file!");
            return;
        }

        const url = window.location.pathname;

        const user = getAuthUser();
        if (!user && !url.includes("invite") && !url.includes("shared")) {
            localStorage.clear();
            window.location.replace("/login");
            return;
        }

        if (!url.includes("invite") && !url.includes("shared")) {
            headers.set('apiToken', user.apiToken);
        }

        headers.set('x-functions-key', code);

        return headers
    }
})